"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APTimePickerDropdown = void 0;
exports["default"] = APTimePicker;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reduxForm = require("redux-form");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _formGeneratorHelper = require("../../../helpers/formGeneratorHelper");
var _dateHelper = require("../../../helpers/dateHelper");
require("./APTimePickerDropdown.css");
var _formValidations = require("../../../helpers/formValidations");
var _excluded = ["label", "meta", "info", "customClass", "leadingZero", "isAMPM"],
  _excluded2 = ["validate", "minTime", "maxTime"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var APTimePickerDropdown = exports.APTimePickerDropdown = /*#__PURE__*/function (_React$Component) {
  function APTimePickerDropdown(props) {
    var _this;
    _classCallCheck(this, APTimePickerDropdown);
    _this = _callSuper(this, APTimePickerDropdown, [props]);
    _defineProperty(_this, "setIsAM", function (date) {
      _this.setState({
        isAM: date.getHours() < 12
      });
    });
    _defineProperty(_this, "handleChange", function (date) {
      _this.props.input.onChange(date);
      if (_this.props.customChange) {
        _this.props.customChange(date);
      }
      _this.setIsAM(date);
      _this.setState({
        date: new Date(date)
      });
    });
    _defineProperty(_this, "getClasses", function () {
      var customClasses = _this.props.customClasses;
      return (0, _cssClassesHelper.getBEMClasses)(['ap-timepicker-dropdown', 'ap-select', customClasses]);
    });
    _defineProperty(_this, "getHours", function () {
      var _this$props = _this.props,
        isAMPM = _this$props.isAMPM,
        leadingZero = _this$props.leadingZero;
      return (0, _formGeneratorHelper.generateOptionsFromNumber)(isAMPM ? 1 : 0, isAMPM ? 13 : 24, leadingZero ? 2 : 0);
    });
    _defineProperty(_this, "onHoursChange", function (e) {
      var value = e.target.value;
      var _this$state = _this.state,
        date = _this$state.date,
        isAM = _this$state.isAM;
      var isAMPM = _this.props.isAMPM;
      var hours = +value;
      if (hours === 12) {
        hours = isAM ? 0 : 12;
      } else {
        hours = isAMPM && !isAM ? +value + 12 : +value;
      }
      date.setHours(hours);
      _this.handleChange(date);
    });
    _defineProperty(_this, "onMinutesChange", function (e) {
      var value = e.target.value;
      var date = _this.state.date;
      date.setMinutes(value);
      _this.handleChange(date);
    });
    _defineProperty(_this, "getCurrentValue", function () {
      var _this$state2 = _this.state,
        date = _this$state2.date,
        isAM = _this$state2.isAM;
      var isAMPM = _this.props.isAMPM;
      var hours = date.getHours();
      if (isAMPM) {
        if (isAM) {
          hours = hours === 0 ? 12 : hours;
        } else {
          hours = hours === 12 ? hours : hours - 12;
        }
      }
      return {
        hours: hours,
        minutes: date.getMinutes()
      };
    });
    _defineProperty(_this, "onAmPmChange", function (e) {
      var value = e.target.value;
      var date = _this.state.date;
      var hours = date.getHours();
      hours = value === 'AM' ? hours - 12 : hours + 12;
      date.setHours(hours);
      _this.handleChange(date);
    });
    _this.state = {
      date: new Date(0, 0, 0, 0, 0, 0),
      isAM: true
    };
    return _this;
  }
  _inherits(APTimePickerDropdown, _React$Component);
  return _createClass(APTimePickerDropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var value = this.props.input.value;
      if (value) {
        var date = new Date(value);
        this.setState({
          date: date
        });
        this.setIsAM(date);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        label = _this$props2.label,
        meta = _this$props2.meta,
        info = _this$props2.info,
        customClass = _this$props2.customClass,
        leadingZero = _this$props2.leadingZero,
        isAMPM = _this$props2.isAMPM,
        otherProps = _objectWithoutProperties(_this$props2, _excluded);
      var isAM = this.state.isAM;
      var baseClasses = this.getClasses();
      var value = this.getCurrentValue();
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group ".concat(baseClasses('select-wrapper'))
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "ap--label ".concat(baseClasses('label'))
      }, label), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('input')
      }, /*#__PURE__*/_react["default"].createElement("select", _extends({
        value: value.hours,
        className: baseClasses('select'),
        onChange: this.onHoursChange
      }, otherProps), this.getHours()), /*#__PURE__*/_react["default"].createElement("select", _extends({
        value: value.minutes,
        className: baseClasses('select'),
        onChange: this.onMinutesChange
      }, otherProps), (0, _formGeneratorHelper.generateOptionsFromNumber)(0, 60, leadingZero ? 2 : 0)), isAMPM && /*#__PURE__*/_react["default"].createElement("select", _extends({
        value: isAM ? 'AM' : 'PM',
        className: baseClasses('select'),
        onChange: this.onAmPmChange
      }, otherProps), /*#__PURE__*/_react["default"].createElement("option", null, "PM"), /*#__PURE__*/_react["default"].createElement("option", null, "AM"))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-text-muted ".concat(baseClasses('info'))
      }, info), meta.dirty && meta.error && /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('error', 'dpk-error')
      }, meta.error));
    }
  }]);
}(_react["default"].Component);
_defineProperty(APTimePickerDropdown, "propTypes", {
  input: _propTypes["default"].object.isRequired,
  label: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  info: _propTypes["default"].string,
  meta: _propTypes["default"].shape({
    touched: _propTypes["default"].bool,
    error: _propTypes["default"].string
  }),
  disabled: _propTypes["default"].bool,
  leadingZero: _propTypes["default"].bool,
  minTime: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]),
  maxTime: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)])
});
_defineProperty(APTimePickerDropdown, "defaultProps", {
  label: 'Time',
  info: '',
  disabled: false,
  leadingZero: true
});
var minTimeProp;
var maxTimeProp;
var minTimeValidation = function minTimeValidation(value) {
  return minTimeProp && (0, _formValidations.minTime)(value, (0, _dateHelper.parseTime)(minTimeProp));
};
var maxTimeValidation = function maxTimeValidation(value) {
  return maxTimeProp && (0, _formValidations.maxTime)(value, (0, _dateHelper.parseTime)(maxTimeProp));
};
var maxMinValidations = [minTimeValidation, maxTimeValidation];
function APTimePicker(props) {
  var validate = props.validate,
    minTime = props.minTime,
    maxTime = props.maxTime,
    otherProps = _objectWithoutProperties(props, _excluded2);
  minTimeProp = minTime;
  maxTimeProp = maxTime;
  var validators = validate ? [].concat(_toConsumableArray(validate), maxMinValidations) : maxMinValidations;
  return /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({}, otherProps, {
    name: props.name,
    component: APTimePickerDropdown,
    validate: validators
  }));
}